export default class Events {
  /**
   * Debounce
   * @return {String} Correct vendor event
   */
  static debounce(fn) {
    let frame;

    return (...params) => {
      if (frame) {
        cancelAnimationFrame(frame);
      }

      frame = requestAnimationFrame(() => {
        // Call our function and pass any params we received
        fn(...params);
      });
    };
  }
}
